import createYCloudIcon from '../createYCloudIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M5.364 3.848C4 6 3 9.652 3 12.652V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5c0-2.334-1.816-4.668-2.622-7.002',
      key: '1c66l9',
    },
  ],
  [
    'path',
    {
      d: 'M7 3h11.379a2 2 0 0 1 1.789 1.106l.723 1.447A1 1 0 0 1 19.997 7h-8.525a2 2 0 0 1-1.789-1.106L8.79 4.105a2 2 0 1 0-3.579 1.789l2.261 4.522A5 5 0 0 1 8 12.652V21',
      key: '8hs01s',
    },
  ],
];

/**
 * @component @name PaperBag
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aAogICAgZD0iTTUuMzY0IDMuODQ4QzQgNiAzIDkuNjUyIDMgMTIuNjUyVjE5YTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMnYtNWMwLTIuMzM0LTEuODE2LTQuNjY4LTIuNjIyLTcuMDAyIgogIC8+CiAgPHBhdGgKICAgIGQ9Ik03IDNoMTEuMzc5YTIgMiAwIDAgMSAxLjc4OSAxLjEwNmwuNzIzIDEuNDQ3QTEgMSAwIDAgMSAxOS45OTcgN2gtOC41MjVhMiAyIDAgMCAxLTEuNzg5LTEuMTA2TDguNzkgNC4xMDVhMiAyIDAgMSAwLTMuNTc5IDEuNzg5bDIuMjYxIDQuNTIyQTUgNSAwIDAgMSA4IDEyLjY1MlYyMSIKICAvPgo8L3N2Zz4K) - https://tianjianjun0727.github.io/ycloud-icons/icons/paper-bag
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/react - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PaperBag = createYCloudIcon('paper-bag', __iconNode);

export default PaperBag;
